import { z } from 'zod';

export const emailDeliverySchema = z.looseObject({
  id: z.string(),
  notification_key: z.string(),
  recipient: z.string(),
  status: z.string(),
  failure_reason: z.string().nullish(),
  attempts: z.number(),
  created_at: z.string().nullish(),
  updated_at: z.string().nullish(),
});

export const emailDeliveryResponseSchema = z.looseObject({
  data: emailDeliverySchema,
});

export const emailDeliveryListResponseSchema = z.looseObject({
  data: z.array(emailDeliverySchema),
});

export type OrderEmailDelivery = z.infer<typeof emailDeliverySchema>;
